import React from 'react';
import noop from 'lodash/noop';
import { lazy, LazyWait } from 'react-loosely-lazy';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import type AddPeopleModalType from '@atlassian/jira-project-add-people';
import {
	type Props,
	AddPeopleModalBoundary,
} from '@atlassian/jira-project-add-people/src/async.tsx';
import type { Party, PartyId, Role } from '@atlassian/jira-project-add-people/src/model';
import { connect } from '@atlassian/jira-react-redux';
import { BACKLOG_PACKAGE_NAME } from '../../../../../common/constants/analytics';
import { getBaseUrl, getProjectKey, projectIdSelector } from '../../../../../state/selectors/app';
import type { State } from '../../../../../state/types';

type OwnProps = {
	isOpen: boolean;
	accessLevel?: string;
	adminRoleId?: number;
	defaultRoleId?: number;
	partiesInProject?: Record<PartyId, Party>;
	projectRoles?: Role[];
	roleConfigurable?: boolean;
	onStopPerfMetric: (() => void) | undefined;
	onClose: (() => void) | undefined;
	onAddSuccess: (() => void) | undefined;
	onError: (() => void) | undefined;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AddPeopleModal = lazy<typeof AddPeopleModalType>(
	() =>
		import(
			/* webpackChunkName: "async-project-add-people-dialog" */ '@atlassian/jira-project-add-people'
		),
);

const Modal = (props: Props) => (
	<AddPeopleModalBoundary packageName={BACKLOG_PACKAGE_NAME}>
		<LazyWait until={props.isOpen}>
			{/* @ts-expect-error - TS2322 - Type '{ isAdmin: boolean; isOpen: boolean; baseUrl: string; projectId: number; projectKey: string; projectType: ProjectType; analyticsPrefix: string; allowFlags: boolean; projectRoles?: Role[] | undefined; ... 8 more ...; onError: (errors: readonly string[]) => void; }' is not assignable to type 'Pick<Pick<ExternalProps, "baseUrl" | "isAdmin" | "onError" | "isOpen" | "onClose" | "projectType" | "projectKey" | "projectId" | "defaultRoleId" | "adminRoleId" | ... 8 more ... | "partiesInProject">, "baseUrl" | ... 10 more ... | "onAddSuccess">'. */}
			<AddPeopleModal {...props} />
		</LazyWait>
	</AddPeopleModalBoundary>
);

export default connect(
	(state: State, ownProps: OwnProps) => ({
		projectId: projectIdSelector(state),
		projectKey: getProjectKey(state),
		baseUrl: getBaseUrl(state),
		isOpen: ownProps.isOpen,
		onClose: ownProps.onClose || noop,
		onError: ownProps.onError || noop,
		onAddSuccess: ownProps.onAddSuccess || noop,
		onStopPerfMetric: ownProps.onStopPerfMetric || noop,
		projectType: SOFTWARE_PROJECT,
		isAdmin: true,
		analyticsPrefix: 'software.backlog',
		allowFlags: true,
	}),
	{},
)(Modal);
